module.exports = __webpack_public_path__ + "./images/plug.svg?e6cfe5ce431c124534758dc616d4ade6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/plug.svg
// module id = 85
// module chunks = 0